import { ImagePlus, RefreshCw, Trash2 } from "lucide-react";

// Publish dialog field: "Choose your preview picture of your note" (optional).
export const PreviewField = ({ preview, onPick, onClear }) =>
  !preview ? (
    <button type="button" data-testid="publish-preview-pick-btn" onClick={onPick}
      className="w-full rounded-xl border border-dashed border-[#3B82F6]/50 bg-[#2563EB]/5 hover:bg-[#2563EB]/10 px-4 py-4 flex items-center gap-3 text-left transition-colors">
      <span className="h-10 w-10 shrink-0 rounded-full bg-[#2563EB]/15 flex items-center justify-center"><ImagePlus className="h-5 w-5 text-[#60A5FA]" /></span>
      <span className="min-w-0">
        <span className="block text-sm font-medium text-[#F3F4F6]">Choose your preview picture of your note</span>
        <span className="block text-[11px] text-[#9CA3AF]">Optional · draw the part buyers see in the banner</span>
      </span>
    </button>
  ) : (
    <div data-testid="publish-preview-chosen" className="rounded-xl border border-[#27272A] bg-[#1E1E1E] overflow-hidden">
      <div className="h-28 overflow-hidden">
        <img src={preview.url} alt="Your preview" className={`h-full w-full object-cover ${preview.blur ? "blur-[3px] scale-110" : ""}`} />
      </div>
      <div className="flex items-center justify-between gap-2 px-3 py-2">
        <span className="text-[11px] text-[#9CA3AF]">{preview.blur ? "Slightly blurred" : "Sharp"} preview</span>
        <div className="flex gap-1">
          <button type="button" data-testid="publish-preview-change-btn" onClick={onPick}
            className="h-7 px-2.5 rounded-full text-[11px] text-[#D1D5DB] hover:bg-[#27272A] flex items-center gap-1"><RefreshCw className="h-3 w-3" /> Change</button>
          <button type="button" data-testid="publish-preview-remove-btn" onClick={onClear}
            className="h-7 px-2.5 rounded-full text-[11px] text-[#FCA5A5] hover:bg-[#27272A] flex items-center gap-1"><Trash2 className="h-3 w-3" /> Remove</button>
        </div>
      </div>
    </div>
  );
